import { Component, computed, input, output, PipeTransform, TemplateRef, OnInit, effect, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { NgTemplateOutlet } from '@angular/common';
import { CustomDropDownArrowDirective } from 'ok-angular-shared/directives';

interface EnumDisplayItem<T> {
  value: T;
  displayText: string;
}

@Component({
  selector: 'adm-admin-enum-select-list-multiple',
  imports: [MatFormFieldModule, MatSelectModule, MatIconModule, CustomDropDownArrowDirective, ReactiveFormsModule, NgTemplateOutlet],
  templateUrl: './admin-enum-select-list-multiple.component.html',
  styleUrl: './admin-enum-select-list-multiple.component.scss',
})
export class AdminEnumSelectListMultipleComponent<T> implements OnInit {
  label = input.required<string>();
  enumChanged = output<T[] | null>();
  initialValue = input<T[] | null>(null);
  template = input<TemplateRef<any>>();
  enumObject = input.required<T[]>();
  translatePipe = input<PipeTransform | null>(null);

  selectedItems = new FormControl<T[]>([]);

  constructor() {
    // Watch for changes to initialValue and update the form control
    effect(() => {
      const newValue = this.initialValue();
      if (newValue !== undefined && newValue !== null) {
        this.selectedItems.setValue(newValue, { emitEvent: false });
      } else {
        this.selectedItems.setValue([], { emitEvent: false });
      }
    });
  }

  ngOnInit() {
    // Subscribe to form control changes and emit to parent
    this.selectedItems.valueChanges.subscribe(value => {
      this.enumChanged.emit(value);
    });
  }

  enumDisplayItems = computed<EnumDisplayItem<T>[]>(() => {
    const enumValues = this.enumObject();
    const pipe = this.translatePipe();
    return enumValues.map(value => {
      const displayText = pipe ? pipe.transform(value) : String(value);
      return { value, displayText };
    });
  });

  getFirstItemName(): string {
    const items = this.enumDisplayItems();
    const firstValue = this.selectedItems.value?.[0];
    if (!firstValue) return '';

    const firstItem = items.find(item => item.value === firstValue);
    return firstItem?.displayText || '';
  }

  compareObjects = (a: T, b: T): boolean => a && b && a === b;

  clearInput(): void {
    this.selectedItems.setValue([]);
    this.enumChanged.emit(null);
  }
}
